import React, { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import { RenterOverview } from "./components/shb/renter/RenterOverview";
import { RenterDetailView } from "./components/shb/renter/RenterDetailView";
import { RenterArchiveOverview } from "./components/shb/archive/RenterArchiveOverview";
import { RenterArchiveDetailView } from "./components/shb/archive/RenterArchiveDetailView";
import { LeadOverview } from "./components/shb/lead/LeadOverview";
import { LeadArchiveOverview } from "./components/shb/lead/LeadArchiveOverview";
import { RentalPriceCalculationDetailView } from "./components/shb/lead/rental-price-calculation/RentalPriceCalculationDetailView";
import { RentalPriceCalculationArchiveDetailView } from "./components/shb/lead/rental-price-calculation/RentalPriceCalculationArchiveDetailView";
import { PropertyOverview } from "./components/shb/property/PropertyOverview";
import { ProfileDetailView } from "./components/renter/ProfileDetailView";
import { DocumentsView } from "./components/renter/DocumentsView";
import { SettingsView } from "./components/renter/SettingsView";
import { ThemeProvider } from "@mui/material";
import { createAppTheme } from "./theme/appTheme";
import ProfileService, { UserRoles } from "./services/ProfileService";
import { appRoutes } from "./constants/AppRoutes";

export default function App() {
  const outerTheme = createAppTheme();

  const init = () => {
    if (ProfileService.getUserDetails() === null) {
      window.location.href = "/Identity/Account/Login";
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <ThemeProvider theme={outerTheme}>
      <Layout>
        <Routes>
          <Route
            path="/"
            element={
              ProfileService.isInRole(UserRoles.codellic) ? (
                <Navigate to={appRoutes.codellic.home} replace />
              ) : ProfileService.isInRole(UserRoles.shb) ? (
                <Navigate to={appRoutes.shb.renter.overview} replace />
              ) : ProfileService.isInRole(UserRoles.renter) ? (
                <Navigate to={appRoutes.renter.profile} replace />
              ) : ProfileService.isInRole(UserRoles.landlord) ? (
                <Navigate to={appRoutes.landlord.home} replace />
              ) : (
                <></>
              )
            }
          />
          <Route
            path={appRoutes.shb.renter.overview}
            element={<RenterOverview />}
          />
          <Route
            path={appRoutes.shb.archive.overview}
            element={<RenterArchiveOverview />}
          />
          <Route
            path={appRoutes.shb.archive._detail}
            element={<RenterArchiveDetailView />}
          />
          <Route
            path={appRoutes.shb.lead.overview}
            element={<LeadOverview />}
          />
          <Route
            path={appRoutes.shb.lead.rentalPriceCalculationArchiveOverview}
            element={<LeadArchiveOverview />}
          />
          <Route
            path={appRoutes.shb.lead._rentalPriceCalculationDetail}
            element={<RentalPriceCalculationDetailView />}
          />
          <Route
            path={appRoutes.shb.lead._rentalPriceCalculationArchiveDetail}
            element={<RentalPriceCalculationArchiveDetailView />}
          />
          <Route
            path={appRoutes.shb.property.overview}
            element={<PropertyOverview />}
          />
          <Route
            path={appRoutes.shb.renter._detail}
            element={<RenterDetailView />}
          />
          <Route
            path={appRoutes.renter.profile}
            element={<ProfileDetailView />}
          />
          <Route
            path={appRoutes.renter.documents}
            element={<DocumentsView />}
          />
          <Route path={appRoutes.renter.settings} element={<SettingsView />} />
        </Routes>
      </Layout>
    </ThemeProvider>
  );
}
